import { createAction } from 'typesafe-actions';
import { ICultivar } from '../../../types/model/masterData/cultivars';

export default class CultivarActions {
    public static setLoading = createAction('MASTER_DATA_CULTIVAR_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_CULTIVARS_SET', resolve => (list : Array<ICultivar>) => resolve(list));
}